import { render, staticRenderFns } from "./account-menu.vue?vue&type=template&id=7f803fde&scoped=true&"
import script from "./account-menu.vue?vue&type=script&lang=js&"
export * from "./account-menu.vue?vue&type=script&lang=js&"
import style0 from "./account-menu.vue?vue&type=style&index=0&id=7f803fde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f803fde",
  null
  
)

export default component.exports